var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{attrs:{"menu":_vm.menu,"menu-style":"compact","menu-active":"tasks","menu-name":"$","no-title":"","hfull":""}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }